import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { 
  Clock, 
  Bell, 
  CheckCircle, 
  Mail,
  Calendar,
  ArrowRight
} from "lucide-react";

const ComingSoonModal = ({ isOpen, onClose, productName }) => {
  const handleNotifyMe = () => {
    // Scroll al formulario de contacto
    onClose();
    setTimeout(() => {
      document.getElementById('contacto').scrollIntoView({ 
        behavior: "smooth" 
      });
    }, 300);
  };

  const getEstimatedDate = (productName) => {
    if (productName === "Recobra360") return "Q1 2025";
    return "Próximamente";
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md mx-auto bg-white border-0 shadow-2xl">
        <div className="text-center p-6">
          {/* Icon Animation */}
          <div className="mb-6">
            <div className="relative mx-auto w-20 h-20">
              <div className="absolute inset-0 bg-gradient-to-br from-[#3E97FF]/10 to-[#27AE60]/10 rounded-full animate-pulse"></div>
              <div className="absolute inset-2 bg-gradient-to-br from-[#3E97FF]/20 to-[#27AE60]/20 rounded-full flex items-center justify-center">
                <Clock className="w-8 h-8 text-[#3E97FF]" />
              </div>
            </div>
          </div>

          <DialogHeader className="space-y-4">
            <DialogTitle className="text-2xl font-bold text-[#252F4A]">
              {productName}
            </DialogTitle>
            <div className="flex justify-center">
              <Badge 
                variant="outline" 
                className="bg-gradient-to-r from-[#3E97FF]/10 to-[#27AE60]/10 border-[#3E97FF] text-[#3E97FF] px-4 py-1"
              >
                <Calendar className="w-4 h-4 mr-2" />
                {getEstimatedDate(productName)}
              </Badge>
            </div>
          </DialogHeader>

          <DialogDescription className="text-base text-[#252F4A]/80 leading-relaxed mb-6">
            Estamos trabajando arduamente en el desarrollo de <strong>{productName}</strong>. 
            Esta solución revolucionaria estará disponible muy pronto y transformará 
            la forma en que gestiones tus procesos.
          </DialogDescription>

          {/* Features Preview */}
          <div className="bg-gradient-to-r from-[#3E97FF]/5 to-[#27AE60]/5 rounded-lg p-4 mb-6">
            <h4 className="font-semibold text-[#252F4A] mb-3 flex items-center justify-center gap-2">
              <CheckCircle className="w-5 h-5 text-[#27AE60]" />
              Lo que puedes esperar:
            </h4>
            <ul className="text-sm text-[#252F4A]/70 space-y-2">
              {productName === "Recobra360" ? (
                <>
                  <li>• Gestión avanzada de cobranza</li>
                  <li>• Automatización inteligente</li>
                  <li>• Reportes analíticos detallados</li>
                  <li>• Integración con sistemas existentes</li>
                </>
              ) : (
                <>
                  <li>• Funcionalidades innovadoras</li>
                  <li>• Interfaz intuitiva y moderna</li>
                  <li>• Integración perfecta</li>
                  <li>• Soporte técnico especializado</li>
                </>
              )}
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Button 
              onClick={handleNotifyMe}
              className="w-full bg-[#3E97FF] hover:bg-[#1C3C73] text-white py-3 rounded-lg transition-all duration-300 hover:shadow-lg flex items-center justify-center gap-2"
            >
              <Bell className="w-4 h-4" />
              Notificarme cuando esté disponible
              <ArrowRight className="w-4 h-4" />
            </Button>
            
            <Button 
              variant="outline"
              onClick={onClose}
              className="w-full border-[#252F4A]/20 text-[#252F4A] hover:bg-[#252F4A]/5 py-3 rounded-lg transition-all duration-300"
            >
              Cerrar
            </Button>
          </div>

          {/* Contact Info */}
          <div className="mt-6 pt-4 border-t border-[#252F4A]/10">
            <p className="text-xs text-[#252F4A]/60 flex items-center justify-center gap-1">
              <Mail className="w-3 h-3" />
              ¿Preguntas? Contáctanos para más información
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ComingSoonModal;